import React, { useState } from "react";

interface UserAvatarProps {
  name?: string | null;
  img?: string | null;
  size?: number;
  fontSize?: number;
  className?: string;
  style?: React.CSSProperties;
}

const getInitials = (name?: string | null): string => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  img,
  size = 32,
  fontSize,
  className,
  style,
}) => {
  const [errored, setErrored] = useState(false);
  const dimension: React.CSSProperties = {
    width: size,
    height: size,
    fontSize: fontSize ?? Math.max(9, Math.round(size * 0.42)),
    flexShrink: 0,
  };
  const showImage = Boolean(img) && !errored;

  if (showImage) {
    return (
      <img
        src={img as string}
        alt={name || "User"}
        className={`rounded-circle ${className || ""}`}
        style={{ ...dimension, objectFit: "cover", ...style }}
        onError={() => setErrored(true)}
      />
    );
  }

  return (
    <div
      className={`rounded-circle text-white d-flex align-items-center justify-content-center fw-semibold ${className || ""}`}
      style={{
        ...dimension,
        background: "linear-gradient(135deg, #3B82F6, #1D4ED8)",
        ...style,
      }}
      title={name || undefined}
    >
      {getInitials(name)}
    </div>
  );
};

export default UserAvatar;
